import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import VerbDropdownButton, { VERB_BUTTON_TYPE } from '../../../../shared/components/VerbDropdownButton';
import VerbButton from '../../../../shared/components/VerbButton';
import { LEARNING_ASSET_TYPES } from '../../../../shared/Constants';

export default class ManageTableButtonSection extends PureComponent {
    static propTypes = {
        onNewItemClick: PropTypes.func,
        isWelcomeAssetTable: PropTypes.bool,
        hideForContentAuthor: PropTypes.bool
    };

    _makeDropdownOptions = () => {
        const { onNewItemClick, hideForContentAuthor } = this.props;
        const baseOptions = [
            {
                text: 'Interactive',
                fontAwesomeIcon: 'fa-pencil-alt',
                fontAwesomeIconWeight: 'far',
                onClick: () => {
                    onNewItemClick(LEARNING_ASSET_TYPES.ACTIVITY, 'Rich Text');
                }
            },
            {
                text: 'Single Page Activity',
                fontAwesomeIcon: 'fa-pencil-alt',
                fontAwesomeIconWeight: 'far',
                onClick: () => {
                    onNewItemClick(LEARNING_ASSET_TYPES.SINGLE_PAGE_ACTIVITY, 'Rich Text');
                }
            },
            {
                text: 'Article',
                fontAwesomeIcon: 'fa-newspaper',
                fontAwesomeIconWeight: 'far',
                onClick: () => {
                    onNewItemClick(LEARNING_ASSET_TYPES.ARTICLE, 'Rich Text');
                }
            },
            {
                text: 'Assessment',
                fontAwesomeIcon: 'fa-file-edit',
                fontAwesomeIconWeight: 'far',
                onClick: () => {
                    onNewItemClick(LEARNING_ASSET_TYPES.ASSESSMENT, 'Rich Text');
                }
            },
            {
                text: 'Video',
                fontAwesomeIcon: 'fa-film',
                fontAwesomeIconWeight: 'far',
                onClick: () => {
                    onNewItemClick(LEARNING_ASSET_TYPES.VIDEO, 'Rich Text');
                }
            },
            {
                text: 'Practical Application',
                fontAwesomeIcon: 'fa-calendar-check',
                fontAwesomeIconWeight: 'far',
                onClick: () => {
                    onNewItemClick(LEARNING_ASSET_TYPES.PRACTICAL_APPLICATION);
                }
            },
            {
                text: 'Reflection',
                fontAwesomeIcon: 'fa-redo',
                fontAwesomeIconWeight: 'fas',
                onClick: () => {
                    onNewItemClick(LEARNING_ASSET_TYPES.REFLECTION);
                }
            },
            {
                text: 'Impact Project',
                fontAwesomeIcon: 'fa-heart',
                fontAwesomeIconWeight: 'far',
                onClick: () => {
                    onNewItemClick(LEARNING_ASSET_TYPES.IMPACT_PROJECT, 'Rich Text');
                }
            },
            {
                text: 'Course',
                fontAwesomeIcon: 'fa-book',
                fontAwesomeIconWeight: 'far',
                onClick: () => {
                    onNewItemClick(LEARNING_ASSET_TYPES.TRACK, 'Rich Text');
                }
            },
            {
                text: 'Feedback',
                fontAwesomeIcon: 'fa-bullhorn',
                fontAwesomeIconWeight: 'far',
                onClick: () => {
                    onNewItemClick(LEARNING_ASSET_TYPES.FEEDBACK, 'Rich Text');
                }
            },
            {
                text: 'Mobile',
                fontAwesomeIcon: 'fa-mobile-android',
                fontAwesomeIconWeight: 'far',
                onClick: () => {
                    onNewItemClick(LEARNING_ASSET_TYPES.MOBILE, 'Rich Text');
                }
            },
            {
                text: 'Pre-Assessment',
                fontAwesomeIcon: 'fa-map-signs',
                fontAwesomeIconWeight: 'far',
                onClick: () => {
                    onNewItemClick(LEARNING_ASSET_TYPES.PRE_ASSESSMENT, 'Rich Text');
                }
            },
            {
                text: 'Post-Assessment',
                fontAwesomeIcon: 'fa-graduation-cap',
                fontAwesomeIconWeight: 'far',
                onClick: () => {
                    onNewItemClick(LEARNING_ASSET_TYPES.POST_ASSESSMENT, 'Rich Text');
                }
            }
        ];

        let dropDownOptions = [...baseOptions];

        return dropDownOptions.sort((a, b) => (a.text > b.text ? 1 : -1));
    };

    makeCreateButton = (isWelcomeAssetTable) => {
        const { onNewItemClick } = this.props;
        if (isWelcomeAssetTable) {
            return (
                <VerbButton
                    buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT}
                    fontAwesomeIcon={'fa-plus'}
                    onClick={() => onNewItemClick(LEARNING_ASSET_TYPES.WELCOME, 'Dynamic Rich Text')}
                >
                    NEW WELCOME FLOW
                </VerbButton>
            );
        }
        return (
            <VerbDropdownButton fontAwesomeIcon={'fa-plus'} dropdownData={this._makeDropdownOptions()}>
                NEW ACTIVITY
            </VerbDropdownButton>
        );
    };

    render() {
        const { isWelcomeAssetTable, hideForContentAuthor } = this.props;

        return (
            <Fragment>
                <div className={'col-12 col-sm-3'}>{this.makeCreateButton(isWelcomeAssetTable)}</div>
                {isWelcomeAssetTable || hideForContentAuthor ? null : (
                    <div className={'col-12 col-sm-3'}>
                        <VerbButton
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                            href={'/copysections'}
                            fontAwesomeIcon={'fa-copy'}
                        >
                            COPY SECTIONS
                        </VerbButton>
                    </div>
                )}
            </Fragment>
        );
    }
}
